import {NgbDateAdapter, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {Injectable} from "@angular/core";
import {DateTime} from "luxon";
import {DateTimeHelper} from "../helper/datetime.helper";

/**
 * ADAPTER de modelo de NgbDatePicker desde moment a moment
 * USA momentjs para parsear y devuelve un objeto momentjs
 * (no noecesariamente el modelo de objetos entienda en temrinos de momentjs
 * ver la utliidad caso por caso)
 */
@Injectable()
export class NgbLuxonDateAdapter extends NgbDateAdapter<DateTime> {

  fromModel(date: DateTime): NgbDateStruct {
    if (!date || !DateTime.isDateTime(date)) {
      return null;
    }

    return {
      year: date.year,
      month: date.month,
      day: date.day,
    };
  }

  toModel(date: NgbDateStruct): DateTime {
    if (!date) {
      return null;
    }
    return DateTime.fromObject({ year:date.year, month:date.month, day:date.day, hour: 0, minute: 0, second:0, millisecond:0 });
  }
}
